// src/utils/spreadsheetMarkingMode.js
// A homework type's Interactive Spreadsheet Marking setting
// (examInteractiveSpreadsheetMarking[type] in the org's marking settings) as
// one of three choices. It was a plain on/off before the choices existed, so
// `true` still means what "on" did then.
//   'pdf'          - off: spreadsheets are marked on the PDF like any page
//   'spreadsheet'  - marked as spreadsheets; the PDF has a "See Spreadsheet N"
//                    note instead of the grid, and the marked spreadsheet
//                    goes in its place in the marked script
//   'both'         - marked as spreadsheets, the grid stays in the PDF too,
//                    and the marked spreadsheets go after the student's pages
export function spreadsheetMarkingMode(value) {
  if (value === 'spreadsheet' || value === 'both') return value;
  return value === true ? 'both' : 'pdf';
}
